import React from 'react'
import { QuarantineBatch } from 'components/QuarantineBatch'
import './styles.scss'
type CountryData = {
  change: string
  code: string
  name: string
  namefr: string
  perPop: number
  quarantine: boolean
  qstart?: string
  qend?: string
  sum14: number
  sum14Before: number
}

export const CountryRow = ({
  el,
  LOCALES,
  isMobile = window.innerWidth < 712
}: {
  el: CountryData
  LOCALES: LOCALE_TYPE
  isMobile?: boolean
}) => {
  const {
    code,
    name,
    namefr,
    sum14,
    perPop,
    sum14Before,
    quarantine,
    qstart,
    qend,
    change
  } = el

  const nf = new Intl.NumberFormat(LOCALES.numberLocale)
  const f = (a: number) => (a < 10000 ? a : nf.format(a))
  let showChange =
    change === 'NaN'
      ? sum14 === 0 && sum14Before === 0
        ? '–'
        : 'aaa'
      : change + '%'

  if (LOCALES.lang === 'fr' && !namefr) return null
  return (
    <div className={'CountryRow ' + (code === 'CH' ? 'highlight' : '')}>
      <div className='wrapper_name'>
        <div className='name'>{LOCALES.lang === 'fr' ? namefr : name}</div>
        <div className='quarantine'>
          <QuarantineBatch
            LOCALES={LOCALES.batch}
            hasQuarantine={quarantine}
            start={qstart !== 'NA' ? qstart : undefined}
            end={qend !== 'NA' ? qend : undefined}
          />
        </div>
      </div>
      <div className='sum14'>
        {f(sum14)}
        {isMobile && <span>{LOCALES.tablehead.previousWeek}</span>}
      </div>
      <div className='perPop'>
        {f(perPop)}
        {isMobile && <span>{showChange}</span>}
      </div>
      <div className='change'>{showChange}</div>
    </div>
  )
}
